import React, { useState, memo, useContext } from 'react';
import { Position, Handle, useReactFlow } from '@xyflow/react';
import { StateContext } from '../StateContainer';
import { PiShuffleFill as ShuffleIcon } from 'react-icons/pi';
import { MdInput as InputIcon } from 'react-icons/md';
import { GoGear as GearIcon } from 'react-icons/go';
import { CiLink as LinkIcon } from 'react-icons/ci';
import { ImCancelCircle as CancelIcon } from 'react-icons/im';
import ModalDeleteNode from './modal/ModalDeleteNode';

function StartNode({ id, data }) {
  const {
    dettagliNodi,
    selectedNode,
    setSelectedNode,
    setCurrentTab,
    setNodeToDelete,
  } = useContext(StateContext);
  let nodo_corrente = dettagliNodi['nodo-' + id];

  const HandleChangeNode = (nodo_corrente) => {
    setCurrentTab('#impostazioniBase');
    setSelectedNode(nodo_corrente);
  };

  return (
    <>
      <div className="card border rounded shadow bg-white position-relative card-start">
        <div data-bs-toggle="modal" data-bs-target="#ModalDeleteNode">
          <CancelIcon
            className="btn-remove-node"
            style={{ cursor: 'pointer', zIndex: 9999 }}
            onClick={() => setNodeToDelete(nodo_corrente)}
          />
        </div>
        {nodo_corrente?.type === 'start' ? (
          <div className="start-node-label">START</div>
        ) : nodo_corrente?.type === 'end' ? (
          <div className="end-node-label">
            <span>END</span>
          </div>
        ) : nodo_corrente?.type === 'relay' ? (
          <div className="relay-node-label fs-5">
            <LinkIcon />
          </div>
        ) : (
          ''
        )}

        <div className="card-header card-header-node text-center bg-green-second text-white d-flex justify-content-between align-items-center">
          <div className="header-content">{nodo_corrente?.node_label}</div>
          <div className="handle-container handle-container-node">
            {nodo_corrente?.type === 'start' ? (
              <Handle type="source" position={Position.Right} />
            ) : nodo_corrente?.type === 'end' ? (
              <Handle type="target" position={Position.Left} />
            ) : (
              <>
                <Handle type="source" position={Position.Right} />
                <Handle type="target" position={Position.Left} />
              </>
            )}
          </div>
        </div>
        <div className="card-body p-0">
          <div className="sezione-nodo" style={{ fontSize: '10px' }}>
            {nodo_corrente?.output?.default_message
              ? String(nodo_corrente?.output?.default_message)
              : ''}
          </div>

          {/* VARIABILI */}
          {nodo_corrente &&
            nodo_corrente.node_variables &&
            nodo_corrente.node_variables.length > 0 && (
              <div className="sezione-nodo">
                <p
                  style={{ fontSize: '12px' }}
                  className="m-0 fw-bold d-flex align-items-center gap-2"
                >
                  <ShuffleIcon /> VARIABILI
                </p>
                {nodo_corrente &&
                  nodo_corrente.node_variables &&
                  nodo_corrente?.node_variables.map((variabile) => {
                    return (
                      <div
                        className={`badge-variabile variabile-${variabile.action}`}
                        style={{ fontSize: '10px' }}
                      >
                        {variabile.nome_variabile}
                      </div>
                    );
                  })}
              </div>
            )}

          {/* FORMATO INPUT */}
          {nodo_corrente && nodo_corrente.widget ? (
            <div className="sezione-nodo">
              <p
                style={{ fontSize: '12px' }}
                className="m-0 fw-bold d-flex align-items-center gap-2"
              >
                <InputIcon /> FORMATO INPUT
              </p>
              <div className="badge-widget" style={{ fontSize: '10px' }}>
                {nodo_corrente.widget.type === 'button' ||
                nodo_corrente.widget.type === 'select'
                  ? 'Risposta Chiusa'
                  : nodo_corrente.widget.type === 'time'
                  ? 'Time Picker'
                  : nodo_corrente.widget.type === 'date'
                  ? 'Data Picker'
                  : 'Testo libero'}
              </div>
            </div>
          ) : null}

          {/* TOOLS */}
          {nodo_corrente &&
          nodo_corrente.external_service &&
          nodo_corrente.external_service.type &&
          nodo_corrente.external_service.type !== '' ? (
            <div className="sezione-nodo">
              <p
                style={{ fontSize: '12px' }}
                className="m-0 fw-bold d-flex align-items-center gap-2"
              >
                <GearIcon /> TOOLS
              </p>
              <div style={{ fontSize: '10px' }}>
                {nodo_corrente.external_service &&
                nodo_corrente.external_service.type === 'invoke'
                  ? 'Invoke'
                  : nodo_corrente.external_service.type === 'mysql'
                  ? 'MySQL'
                  : ''}
              </div>
            </div>
          ) : (
            ''
          )}
          <button
            className="btn button-modifica-nodo w-100 border-0"
            onClick={() => HandleChangeNode(nodo_corrente)}
          >
            Modifica
          </button>
        </div>
      </div>
    </>
  );
}

export default memo(StartNode);
